module.exports = __webpack_public_path__ + "img/sweden.d46dbac2.svg";